import React from "react";
import MapComponent from "./MapComponent";

function HomePage() {
  const position = [39.92612659422686, 9.666396315872941]; // Coordinata di Londra per esempio

  return (
    <div>
      <MapComponent position={position} />
    </div>
  );
}

export default HomePage;
